import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/environment-desktop.webp';
import imageMobileWebp from './images/environment-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-environment'
    moduleName='financial-planning-module'
    themeType='lightTheme'
    backgroundVariant='lightA'
    reverseContent={false}
    // content
    subHeadingText={<>Reducing our <WidowBlock>environmental impact</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          We implement environmentally&#45;sensitive practices, caring for people and the planet.
        </Typography>
        <Link
          id='sustainability-impact-environment-link'
          variant='buttonLinkSecondary'
          linkUrl='/who-we-are/sustainability-impact/environment/'
          ariaLabel='Find out more about reducing our environmental impact.'>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='A person walking outside of the Northwestern Mutual office in the green space area'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
